// delivery-date-utils.js
// GENERATED FILE - DO NOT EDIT DIRECTLY
// Source: apps/sincere-checkout-ext/extensions/checkout-delivery-date/src/deliveryDateUtils.js
// This file is auto-generated by scripts/transpile-utils.js

// CONFIGURATION
// Configurable values (can be overridden before calling)
window.DELIVERY_DATE_CONFIG = {
  daysUntilFirstDelivery: 3,
  disableSundays: true,
  allowableDeliveryDaysFromToday: 21
};

// Dates that require 7-day advance ordering (local time)
var SPECIAL_ADVANCE_DATES = [
  '2025-11-29',
  '2025-12-26',
  '2026-01-02'
];

// Dates that are always unavailable for delivery (holiday blackout)
var BLACKOUT_DATES = [
  '2025-11-27', // Thanksgiving Thursday
  '2025-11-28', // Thanksgiving Friday
  '2025-12-25', // Christmas
  '2026-01-01'  // New Year's Day
];

function formatDateISO(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

function isBlackoutDate(date) {
  return BLACKOUT_DATES.includes(formatDateISO(date));
}

function isMonday(date) {
  return date.getDay() === 1;
}

function isMondayUnavailable(deliveryDate, today) {
  if (!isMonday(deliveryDate)) return false;
  today = today || new Date();
  today.setHours(0, 0, 0, 0);
  const todayDay = today.getDay();
  if (todayDay === 2) return false;
  const daysDiff = Math.floor((deliveryDate.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
  return daysDiff >= 0 && daysDiff <= 6;
}

function isSpecialAdvanceDate(date) {
  return SPECIAL_ADVANCE_DATES.includes(formatDateISO(date));
}

function isSpecialAdvanceDateAvailable(date, today) {
  today = today || new Date();
  today.setHours(0, 0, 0, 0);
  const daysDiff = Math.floor((date.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
  return daysDiff >= 7;
}

function findFirstValidDate(startDate) {
  const cfg = window.DELIVERY_DATE_CONFIG;
  const lastAvailable = new Date();
  lastAvailable.setDate(lastAvailable.getDate() + cfg.allowableDeliveryDaysFromToday);
  lastAvailable.setHours(0, 0, 0, 0);
  let date = new Date(startDate);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  while (date <= lastAvailable) {
    // Blackout date rule
    if (isBlackoutDate(date)) {
      date.setDate(date.getDate() + 1);
      continue;
    }
    // Special advance date rule
    if (isSpecialAdvanceDate(date) && !isSpecialAdvanceDateAvailable(date, today)) {
      date.setDate(date.getDate() + 1);
      continue;
    }
    const validDate = (!cfg.disableSundays || date.getDay() !== 0) && !isMondayUnavailable(date, today);
    if (validDate) {
      return date;
    }
    date.setDate(date.getDate() + 1);
  }
  return startDate;
}

function getDisallowedDatesForCalendar() {
  const today = new Date();
  const todayDay = today.getDay();
  const disallowedDates = BLACKOUT_DATES.slice();

  // Special advance dates not available (less than 7 days in advance)
  for (const iso of SPECIAL_ADVANCE_DATES) {
    const [year, month, day] = iso.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    date.setHours(0, 0, 0, 0);
    const daysDiff = Math.floor((date.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
    if (daysDiff < 7) {
      disallowedDates.push(iso);
    }
  }

  // Disallowed Mondays
  if (todayDay !== 2) {
    for (let i = 0; i <= 6; i++) {
      const checkDate = new Date(today);
      checkDate.setDate(today.getDate() + i);
      if (checkDate.getDay() === 1) {
        disallowedDates.push(formatDateISO(checkDate));
      }
    }
  }

  return disallowedDates.join(', ');
}

// Validate if a date string is currently valid for delivery
function isDateValid(dateString) {
  if (!dateString) return false;

  // Parse YYYY-MM-DD as local date, not UTC
  const [year, month, day] = dateString.split('-').map(Number);
  const date = new Date(year, month - 1, day);
  date.setHours(0, 0, 0, 0);

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  // Calculate valid date range
  const firstAvailableDate = new Date();
  firstAvailableDate.setDate(today.getDate() + window.DELIVERY_DATE_CONFIG.daysUntilFirstDelivery);
  firstAvailableDate.setHours(0, 0, 0, 0);

  const lastAvailableDate = new Date();
  lastAvailableDate.setDate(today.getDate() + window.DELIVERY_DATE_CONFIG.allowableDeliveryDaysFromToday);
  lastAvailableDate.setHours(0, 0, 0, 0);

  // Check if date is within valid range
  if (date < firstAvailableDate || date > lastAvailableDate) {
    return false;
  }

  // Check if it's a blackout date
  if (isBlackoutDate(date)) {
    return false;
  }

  // Check if it's a restricted Monday
  if (isMondayUnavailable(date, today)) {
    return false;
  }

  // Check if it's a special advance date without enough notice
  if (isSpecialAdvanceDate(date) && !isSpecialAdvanceDateAvailable(date, today)) {
    return false;
  }

  // Check if Sundays are disabled
  if (window.DELIVERY_DATE_CONFIG.disableSundays && date.getDay() === 0) {
    return false;
  }

  return true;
}

// Format date for display (e.g., "Wednesday, October 15, 2025")
function formatDateDisplay(dateString) {
  // Parse YYYY-MM-DD as local date, not UTC
  const [year, month, day] = dateString.split('-').map(Number);
  const date = new Date(year, month - 1, day);

  return date.toLocaleDateString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
}

// Export functions to window namespace for browser use
window.findFirstValidDate = findFirstValidDate;
window.getDisallowedDatesForCalendar = getDisallowedDatesForCalendar;
window.isDateValid = isDateValid;
window.formatDateDisplay = formatDateDisplay;

// Usage: window.findFirstValidDate(new Date())
